import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const text = css`
  padding-inline: 0 !important;
  inline-size: max-content;
`

export const iconSpotWrapper = css`
  padding: ${spacing(0.6)};
  border-radius: ${spacing(100)};
  border: 1px solid ${cssTheme.default.day.line};
`

export const title = css`
  inline-size: fit-content;
`
